import React from 'react'

export default function NotFound() {
  return (
    <div className='text-white h1'>NotFound</div>
  )
}
